<template>
  <v-card elevation="4" class="dashboard-card personal-card rounded-xl fill-height">
    <div class="personal-header">
      <div class="personal-title-wrap">
        <v-avatar color="rgba(36, 202, 212, 0.16)" size="42" class="mr-3">
          <v-icon color="primary">mdi-account</v-icon>
        </v-avatar>
        <div>
          <div class="personal-title">Información personal</div>
          <div class="personal-subtitle">Datos de contacto registrados</div>
        </div>
      </div>
    </div>
    <div class="personal-content">
      <div class="personal-item">
        <div class="personal-icon personal-icon-primary">
          <v-icon color="primary" size="24">mdi-map-marker</v-icon>
        </div>
        <div class="personal-copy">
          <span class="personal-label">Dirección</span>
          <strong>{{ personalInfo.direccion }}</strong>
        </div>
      </div>
      <div class="personal-item">
        <div class="personal-icon personal-icon-secondary">
          <v-icon color="primary" size="24">mdi-cellphone</v-icon>
        </div>
        <div class="personal-copy">
          <span class="personal-label">Móvil</span>
          <strong>{{ personalInfo.movil }}</strong>
        </div>
      </div>
      <div class="personal-item">
        <div class="personal-icon personal-icon-accent">
          <v-icon color="primary" size="24">mdi-email</v-icon>
        </div>
        <div class="personal-copy">
          <span class="personal-label">Correo personal</span>
          <strong>{{ personalInfo.email }}</strong>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import conv from "@/services/conversores";
import funciones from "@/services/funciones";

export default {
  name: "PersonalInfoCard",
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  computed: {
    personalInfo() {
      const direccion = this.user?.direccion_particular;
      const movil = this.user?.Movil;
      const email = this.user?.email_personal;

      return {
        direccion: direccion && direccion.trim().length > 0
          ? conv.capitalizeString(direccion.trim())
          : "No hay registro",
        movil: movil && parseInt(movil.trim()) > 0 ? movil.trim() : "No hay registro",
        email: funciones.validateEmail(email) ? email.toLowerCase().trim() : "No hay registro"
      };
    }
  }
};
</script>

<style scoped>
.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.personal-card {
  background: linear-gradient(135deg, #ffffff 0%, rgba(36, 202, 212, 0.05) 100%) !important;
  overflow: hidden;
  padding: 0;
}

.personal-header {
  align-items: center;
  color: #20333a;
  display: flex;
  justify-content: space-between;
  min-height: 76px;
  padding: 18px 22px 12px;
}

.personal-title-wrap {
  align-items: center;
  display: flex;
  min-width: 0;
}

.personal-title {
  font-size: 1.28rem;
  font-weight: 700;
  line-height: 1.1;
}

.personal-subtitle {
  color: #4d6870;
  font-size: 0.82rem;
  margin-top: 3px;
}

.personal-content {
  display: grid;
  background: #ffffff;
  border: 1px solid rgba(37, 108, 116, 0.1);
  border-radius: 14px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.55);
  gap: 0;
  grid-template-columns: minmax(230px, 1.35fr) minmax(150px, 0.75fr) minmax(210px, 1fr);
  margin: 0 20px 20px;
  padding: 20px;
}

.personal-item {
  align-items: flex-start;
  display: flex;
  gap: 11px;
  min-width: 0;
  padding: 0 18px;
}

.personal-item + .personal-item {
  border-left: 1px solid rgba(37, 108, 116, 0.14);
}

.personal-icon {
  align-items: center;
  border-radius: 12px;
  display: flex;
  flex: 0 0 auto;
  height: 48px;
  justify-content: center;
  width: 48px;
}

.personal-icon-primary {
  background: rgba(37, 108, 116, 0.12);
}

.personal-icon-secondary {
  background: rgba(36, 202, 212, 0.16);
}

.personal-icon-accent {
  background: rgba(37, 108, 116, 0.09);
}

.personal-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.personal-label {
  color: #60757b;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 3px;
  text-transform: uppercase;
}

.personal-item strong {
  color: #20333a;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

@media (max-width: 959px) {
  .personal-content {
    grid-template-columns: 1fr;
    padding: 8px 18px;
  }

  .personal-item {
    padding: 14px 0;
  }

  .personal-item + .personal-item {
    border-left: 0;
    border-top: 1px solid rgba(37, 108, 116, 0.14);
  }
}

@media (max-width: 599px) {
  .personal-header {
    min-height: auto;
    padding: 16px 18px 10px;
  }

  .personal-content {
    margin: 0 14px 14px;
    padding: 4px 14px;
  }
}
</style>
